import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './features23.css'

const Features23 = (props) => {
  return (
    <div 
      id="skills" 
      className={`features23-layout349 thq-section-padding ${props.rootClassName} `}
    >
      <div className="features23-max-width thq-section-max-width">
        <div className="features23-container10">
          <h2>
            {props.heading1}
          </h2>
          <span>
            {props.content1}
          </span>
        </div>
        <div className="thq-grid-3">
          <div className="features23-thq-card features23-thq-card-yellow thq-card">
            <img
              alt={props.feature2ImageAlt}
              src={props.feature2ImageSrc}
              className="features23-image thq-img-round"
            />
            <h2>
              {props.feature2Title ?? (
                <Fragment>
                  <h2 className="features23-text46 thq-heading-2">
                    <span>Business Process Management (BPM)</span>
                    <br></br>
                  </h2>
                </Fragment>
              )}
            </h2>
            <span>
              {props.feature2Description ?? (
                <Fragment>
                  <span className="features23-text49 thq-body-small">
                    We specialize in automating business processes from start to
                    finish, ensuring that human, robotic, and system activities
                    are seamlessly integrated. Our BPM solutions provide a clear
                    roadmap for each process, enabling all stakeholders to
                    understand what needs to be done and when.
                  </span>
                </Fragment>
              )}
            </span>
          </div>
          <div className="features23-thq-card features23-thq-card-white thq-card">
            <img
              alt={props.feature3ImageAlt}
              src={props.feature3ImageSrc}
              className="features23-image thq-img-round"
            />
            <h2>
              {props.feature3Title ?? (
                <Fragment>
                  <h2 className="features23-text41 thq-heading-2">
                    <span>Business Rules Management (Decisions)</span>
                    <br></br>
                  </h2>
                </Fragment>
              )}
            </h2>
            <span>
              {props.feature3Description ?? (
                <Fragment>
                  <span className="features23-text38 thq-body-small">
                    We streamline the management of your business rules by
                    centralizing, defining, classifying and automating them. We
                    help creating rules that support workflows, ensuring that
                    critical decisions, such as product scoring or offer
                    optimization, are consistent, efficient, and reliable.
                  </span>
                </Fragment>
              )}
            </span>
          </div>
          <div className="features23-thq-card features23-thq-card-yellow thq-card">
            <img
              alt={props.feature4ImageAlt}
              src={props.feature4ImageSrc}
              className="features23-image thq-img-round"
            />
            <h2>
              {props.feature4Title ?? (
                <Fragment>
                  <h2 className="features23-text31 thq-heading-2">
                    <span>Artificial Intelligence &amp; Machine Learning</span>
                    <br></br>
                  </h2>
                </Fragment>
              )}
            </h2>
            <span>
              {props.feature4Description ?? (
                <Fragment>
                  <span className="features23-text35 thq-body-small">
                    By bringing intelligence into your business, we help you
                    predict trends, automate decisions, and improve overall
                    process performance.
                  </span>
                </Fragment>
              )}
            </span>
          </div>
        </div>
        <div className="thq-grid-3 thq-grid-4">
          <div className="features23-thq-card features23-thq-card-yellow thq-card">
            <img
              alt={props.feature2ImageAlt1}
              src={props.feature2ImageSrc1}
              className="features23-image thq-img-round"
            />
            <h2>
              {props.feature2Title1 ?? (
                <Fragment>
                  <h2 className="features23-text36 thq-heading-2">
                    Robotics Process Automation (RPA)
                  </h2>
                </Fragment>
              )}
            </h2>
            <span>
              {props.feature2Description1 ?? (
                <Fragment>
                  <span className="features23-text34 thq-body-small">
                    We build RPA solutions to free your employees from
                    time-consuming, repetitive tasks, allowing them to focus on
                    more strategic activities and help you achieve significant
                    efficiency gains.
                  </span>
                </Fragment>
              )}
            </span>
          </div>
          <div className="features23-thq-card features23-thq-card-white thq-card">
            <img
              alt={props.feature3ImageAlt1}
              src={props.feature3ImageSrc1}
              className="features23-image thq-img-round"
            />
            <h2>
              {props.feature3Title1 ?? (
                <Fragment>
                  <h2 className="features23-text30 thq-heading-2">
                    Intelligent Document Processing
                  </h2>
                </Fragment>
              )}
            </h2>
            <span>
              {props.feature3Description1 ?? (
                <Fragment>
                  <span className="features23-text50 thq-body-small">
                    We build solutions to capture and store documents
                    intelligently, adding insights and analytical tools that
                    enhance data manipulation and understanding. Our approach
                    ensures efficient storage and effective management of both
                    digitized and automatically generated documents.
                  </span>
                </Fragment>
              )}
            </span>
          </div>
          <div className="features23-thq-card features23-thq-card-yellow thq-card">
            <img
              alt={props.feature4ImageAlt1}
              src={props.feature4ImageSrc1}
              className="features23-image thq-img-round"
            />
            <h2>
              {props.feature4Title1 ?? (
                <Fragment>
                  <h2 className="features23-text51 thq-heading-2">
                    Data Analytics &amp; BI
                  </h2>
                </Fragment>
              )}
            </h2>
            <span>
              {props.feature4Description1 ?? (
                <Fragment>
                  <span className="features23-text44 thq-body-small">
                    The automation of processes, documents and data capture from
                    our clients generates valuable information ready for
                    exploration, offering significant competitive advantages. We
                    guide our clients on this discovery, helping them unlock the
                    full potential of their data.
                  </span>
                </Fragment>
              )}
            </span>
          </div>
          <div className="features23-thq-card features23-thq-card-white thq-card">
            <img
              alt={props.feature3ImageAlt11}
              src={props.feature3ImageSrc11}
              className="features23-image thq-img-round"
            />
            <h2>
              {props.feature3Title11 ?? (
                <Fragment>
                  <h2 className="features23-text37 thq-heading-2">
                    System Integrations
                  </h2>
                </Fragment>
              )}
            </h2>
            <span>
              {props.feature3Description11 ?? (
                <Fragment>
                  <span className="features23-text45 thq-body-small">
                    We help businesses integrate their internal and external
                    systems, creating a cohesive IT environment that supports
                    all aspects of operations. Whether you need to connect
                    legacy systems or integrate with external applications, we
                    provide solutions that ensure seamless communication and
                    data flow.
                  </span>
                </Fragment>
              )}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

Features23.defaultProps = {
  feature2Title: undefined,
  feature2ImageAlt: 'BPM Image',
  feature2Description: undefined,
  feature2ImageSrc:
    '/images/skills_bpm.png',

  feature2ImageAlt1: 'RPA Image',
  feature2Description1: undefined,
  feature2Title1: undefined,
  feature2ImageSrc1:
  '/images/skills_robotics.png',


  feature3ImageAlt: 'Decisions Image',
  feature3Description: undefined,
  feature3Title: undefined,
  feature3ImageSrc:
  '/images/skills_decisions.png',
  
  feature4Title: undefined,  
  feature4Description: undefined,
  feature4ImageAlt: 'AI Image',
  feature4ImageSrc:
    '/images/skills_ai.png',

  feature4ImageAlt1: 'Data Image',
  feature4Title1: undefined,
  feature4Description1: undefined,
  feature4ImageSrc1:
    '/images/skills_data.png',
  
    
  feature3ImageAlt1: 'Documents Image',
  feature3Description1: undefined,
  feature3Title1: undefined,
  feature3ImageSrc1:
    '/images/skills_documents.png',

  
  feature3ImageAlt11: 'Integrations Image',
  feature3Description11: undefined,
  feature3Title11: undefined,
  feature3ImageSrc11:
    '/images/skills_integrations.png',



  text: undefined,
  rootClassName: '',  
  content1: undefined,
  heading1: undefined,
  
  
}

Features23.propTypes = {
  feature3ImageAlt: PropTypes.string,
  feature4ImageSrc: PropTypes.string,
  text: PropTypes.element,
  feature3Title1: PropTypes.element,
  feature3ImageSrc11: PropTypes.string,
  rootClassName: PropTypes.string,
  feature2ImageSrc1: PropTypes.string,
  feature4Title: PropTypes.element,
  feature2ImageAlt1: PropTypes.string,
  feature2Description1: PropTypes.element,
  feature3ImageAlt11: PropTypes.string,
  feature4Description: PropTypes.element,
  feature2Title1: PropTypes.element,
  feature3ImageAlt1: PropTypes.string,
  feature3Title11: PropTypes.element,
  feature3Description: PropTypes.element,
  content1: PropTypes.element,
  feature2ImageAlt: PropTypes.string,
  feature4ImageSrc1: PropTypes.string,
  heading1: PropTypes.element,
  feature3Title: PropTypes.element,
  feature3ImageSrc1: PropTypes.string,
  feature4ImageAlt: PropTypes.string,
  feature3ImageSrc: PropTypes.string,
  feature4ImageAlt1: PropTypes.string,
  feature4Description1: PropTypes.element,
  feature3Description11: PropTypes.element,
  feature2Title: PropTypes.element,
  feature2Description: PropTypes.element,
  feature2ImageSrc: PropTypes.string,
  feature3Description1: PropTypes.element,
  feature4Title1: PropTypes.element,
}

export default Features23
